import billManagementTable from '../../../../components/reimbursement/billManagementTable'
export default {
  components: {
    billManagementTable
  },
  data() {
    return {
      activeName: 'all',
      queryData: {

      },
      pageConfig: {
        currentPage: 1,
        pageSizes: [20, 50, 100, 200],
        pageSize: 50,
        total: 0
      },
      tableData: []
    }
  },
  mounted() {

  },
  created() {
    this.queryBillData()

  },
  methods: {

    /* 切换页签 */
    handleClick(tab, event) {
      console.log(this.activeName)
      this.queryBillData()
    },
    /* 每页多少条 */
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.queryBillData()
    },
    // 调制 第几页
    handleCurrentChange(currentpage) {
      this.pageConfig.currentPage = currentpage
      this.queryBillData()
    },
    queryBillData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        invoiceType: this.activeName ? this.activeName : '',
        invoiceCode: this.queryData.invoiceCode ? this.queryData.invoiceCode : null,
        invoiceNum: this.queryData.invoiceNum ? this.queryData.invoiceNum : null,
        currentPage: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize
      }
      this.$post('/fesback/billManagement/getList.z', data).then(res => {

        if (res.success) {
          const data = res.data
          this.tableData = data.data
          this.pageConfig.total = data.count
        }
        loading.close()
      })


    }

  }

}
